export const TIME_INFO = 1300
export const TIME_RESULT = 2500